import injectSheet from 'react-jss'
import CheckedInStatus from './CheckedInStatus'
import styles from './CheckedInStatus.styles'

export default injectSheet(styles)(CheckedInStatus)
